import Row from '../Common/Row';
import CanvasCardTitle from '../CanvasCardTitle';
import ShowOnMouseOverUnlessTour from '../ShowOnMouseOverUnlessTour';
import EditListButton from './EditListButton';
import CopyGadgetButton from '../CopyGadgetButton';
import React, { useCallback, useContext, useState } from 'react';
import MetricListContext from '../../contexts/MetricListContext';
import MetricsInfoButton from '../MetricsInfoButton';
import ContextMenu from '../../kingpin/atoms/ContextMenu';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import ConfigureMetricList from './ConfigureMetricList';
import DateInputContext from '../../contexts/DateInputContext';
import GadgetFullscreenButton from '../GadgetFullscreen/GadgetFullscreenButton';
import { useGadgetFullscreen } from '../GadgetFullscreen/GadgetFullscreenProvider';

const MetricListTopBar = ({ isPreview }: { isPreview?: boolean }) => {
  const { metricList } = useContext(MetricListContext);
  const originalListContext = useContext(DateInputContext);
  const { isFullscreen } = useGadgetFullscreen();
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [isAutoModalOpen, setIsAutoModalOpen] = useState<boolean>(false);

  const onMenuOpen = useCallback(() => {
    setIsMenuOpen(true);
  }, []);
  const onMenuClose = useCallback(() => {
    setIsMenuOpen(false);
  }, []);

  const closeAutoModal = useCallback(() => setIsAutoModalOpen(false), []);

  if (!metricList) {
    return null;
  }

  return (
    <Row spaceBetween centerAlign style={{ height: '100%' }}>
      <CanvasCardTitle title={metricList.name} />
      {!isPreview && !isFullscreen && (
        <Row>
          <GadgetFullscreenButton />
          <ShowOnMouseOverUnlessTour>
            <div style={{ marginRight: 8 }}>
              <MetricsInfoButton visualisation={metricList} />
            </div>
          </ShowOnMouseOverUnlessTour>
          <ShowOnMouseOverUnlessTour isForcedVisible={isMenuOpen}>
            <ContextMenu
              buttonType="Ghost"
              onOpen={onMenuOpen}
              onClose={onMenuClose}
            >
              <EditListButton metricListGadget={metricList} />
              <CopyGadgetButton />
            </ContextMenu>
          </ShowOnMouseOverUnlessTour>
        </Row>
      )}
      <ModalTransition>
        {isAutoModalOpen && !isPreview && (
          <Modal
            onClose={closeAutoModal}
            shouldScrollInViewport={false}
            autoFocus={false}
            width={'95vw'}
            height={'80vh'}
          >
            <ConfigureMetricList
              metricListGadget={metricList}
              close={closeAutoModal}
              originalListContext={originalListContext}
            />
          </Modal>
        )}
      </ModalTransition>
    </Row>
  );
};

export default MetricListTopBar;
